module.exports = __webpack_public_path__ + "img/need-write-morningpages.d46aad92.jpg";